export default [
    {
        path: '/time-sheet-approvals',
        name: 'time-sheet-approvals',
        component: () => import ('./views/ApprovalIndex'),
        meta: {
            title: 'Visualizar Ocorrências',
            icon: 'mdi-bookmark-check-outline',
            breadcrumbs: [
                { text: 'Folha de Ponto', disabled: true, href: '/' }, 
                { text: 'Aprovação', disabled: true, href: '/' }, 
            ],
        }
    },
]
